const BID_VALIDATION_RESULTS = {
    AUCTION_HAS_ENDED: 'AuctionHasEnded',
    AUCTION_HAS_NOT_STARTED: 'AuctionHasNotStarted',
    BELOW_MINIMUM: 'BelowMinimum',
    BELOW_OWN_LEADING_BID: 'BelowOwnLeadingBid',
    BELOW_RESERVE_PRICE: 'BelowReservePrice',
    BID_NOT_FOUND: 'BidNotFound',
    BIDDER_IS_BLOCKED: 'BidderIsBlocked',
    BIDDING_OR_BUYING_OWN_ITEM: 'BiddingOrBuyingOwnItem',
    BUYING_LIMIT_REACHED: 'BuyingLimitReached',
    EQUAL_OR_HIGHER_THAN_BUY_IT_NOW: 'EqualOrHigherThanBuyItNow',
    HIGHER_BIDDER_EXISTS: 'HigherBidderExists',
    ITEM_NO_LONGER_AVAILABLE: 'ItemNoLongerAvailable',
    ITEM_NOT_FOUND: 'ItemNotFound',
    LEADING_BIDDER: 'LeadingBidder',
    NO_LONGER_VALID: 'NoLongerValid',
    ONLY_EU_BUYERS_ACCEPTED: 'OnlyEUBuyersAccepted',
    ONLY_NORDIC_BUYERS_ACCEPTED: 'OnlyNordicBuyersAccepted',
    ONLY_SWEDISH_BUYERS_ACCEPTED: 'OnlySwedishBuyersAccepted',
    SUCCESSFULLY_CHANGED_AUTOBID: 'SuccessfullyChangedAutoBid',
    USER_IS_SUSPENDED: 'UserIsSuspended',
    MAX_PLACED_BIDS_LIMIT: 'MaxPlacedBidsLimit',
    BID_AMOUNT_LIMIT: 'BidAmountLimit',
    OFFLINE: 'Offline'
};

const BID_VALIDATION_SUCCESSES: string[] = [
    BID_VALIDATION_RESULTS.LEADING_BIDDER,
    BID_VALIDATION_RESULTS.SUCCESSFULLY_CHANGED_AUTOBID
];

const BID_VALIDATION_RETRY: string[] = [
    BID_VALIDATION_RESULTS.BELOW_MINIMUM,
    BID_VALIDATION_RESULTS.BELOW_RESERVE_PRICE,
    BID_VALIDATION_RESULTS.BELOW_OWN_LEADING_BID,
    BID_VALIDATION_RESULTS.HIGHER_BIDDER_EXISTS,
    BID_VALIDATION_RESULTS.OFFLINE
];

const BIN_VALIDATION_RESULTS = {
    ITEM_NOT_FOUND: 'ItemNotFound',
    ONLY_EU_BUYERS_ACCEPTED: 'OnlyEUBuyersAccepted',
    ONLY_NORDIC_BUYERS_ACCEPTED: 'OnlyNordicBuyersAccepted',
    ONLY_SWEDISH_BUYERS_ACCEPTED: 'OnlySwedishBuyersAccepted',
    USER_IS_SUSPENDED: 'UserIsSuspended',
    BIDDER_IS_BLOCKED: 'BidderIsBlocked',
    ITEM_HAS_ENDED: 'ItemHasEnded',
    BUYING_OWN_ITEM: 'BuyingOwnItem',
    ITEM_ALREADY_PURCHASED_BY_OTHER_USER: 'ItemAlreadyPurchasedByOtherUser',
    PURCHASE_DID_NOT_SUCCEED: 'PurchaseDidNotSucceed'
};

export {
    BID_VALIDATION_RESULTS,
    BID_VALIDATION_SUCCESSES,
    BID_VALIDATION_RETRY,
    BIN_VALIDATION_RESULTS
};
